import { DateTime } from "luxon";
import { toast } from "react-toastify";

export const validateFlightSearch = (form) => {
  const msgs = [];
  if (!form.origin.origin_meta.length) {
    msgs.push("Please select an origin airport");
  }
  if (!form.destination.destination_meta.length) {
    msgs.push("Please select a destination airport");
  }
  if (
    form.origin.origin_meta[0] &&
    form.destination.destination_meta[0] &&
    form.origin.origin_meta[0].iata ===
      form.destination.destination_meta[0].iata
  ) {
    msgs.push("Both origin and destination have the same airport");
  }
  if (form.isRoundTrip && !form.inbound_departure) {
    msgs.push("Please select a returning date.");
  }
  if (
    DateTime.fromISO(form.outbound_departure).startOf("day") >=
    DateTime.fromISO(form.inbound_departure).startOf("day")
  ) {
    msgs.push(
      "Please select a returning date later than the origin departure date."
    );
  }
  if (!form.outbound_departure) {
    msgs.push("Please select date.");
  }
  if (form.children > 0 && form.children_ages?.length !== form.children) {
    msgs.push("Please set ages for all children.");
  }
  if (msgs.length) {
    toast.warning(
      <ul>
        {msgs.map((msg, idx) => (
          <li key={idx}>{msg}</li>
        ))}
      </ul>,
      { duration: 5000 }
    );
    return false;
  }
  return true;
};

export function getFieldsOptions({ name, t }) {
  const options = {
    stops: [
      {
        value: "AllFlight",
        label: t("anyFlights"),
      },
      {
        value: "Direct",
        label: t("directFlights"),
      },
    ],
    flightClass: [
      {
        value: "All",
        label: t("noClassPreference"),
      },
      {
        value: "Economy",
        label: t("economy"),
      },
      {
        value: "Business",
        label: t("business"),
      },
      {
        value: "First",
        label: t("first"),
      },
      {
        value: "PremiumEconomy",
        label: t("premiumEconomy"),
      },
    ],
    roundTrip: [
      {
        value: false,
        label: t("oneWay"),
      },
      {
        value: true,
        label: t("roundTrip"),
      },
    ],
    withBaggage: [
      {
        value: true,
        label: t("withBaggage"),
      },
      {
        value: false,
        label: t("noBaggagePreference"),
      },
    ],
  };
  return options[name];
}
